import ImageTagModel from '../../models/IDaq/ImageTagModel';
import BaseStore from '../BaseStore';
import {observable} from "mobx/lib/mobx";

class ImageTagStore extends BaseStore {
  constructor(transportLayer) {
    super(ImageTagModel, transportLayer);
  }

  updateImageTags = (tags) => {
    return this.transportLayer.updateImageTags(tags);
  }
}

export default ImageTagStore;


// WEBPACK FOOTER //
// ./src/stores/IDaq/ImageTagStore.js